"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomingBeaconMessageInterceptor = void 0;
const __1 = require("..");
class IncomingBeaconMessageInterceptor {
    static async intercept(config) {
        const { message, connectionInfo, appMetadataManager, interceptorCallback } = config;
        switch (message.type) {
            case __1.BeaconMessageType.PermissionRequest:
                {
                    await appMetadataManager.addAppMetadata(message.appMetadata);
                    const request = message;
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case __1.BeaconMessageType.OperationRequest:
                {
                    const appMetadata = await IncomingBeaconMessageInterceptor.getAppMetadata(appMetadataManager, message.beaconId);
                    const request = {
                        appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case __1.BeaconMessageType.SignPayloadRequest:
                {
                    const appMetadata = await IncomingBeaconMessageInterceptor.getAppMetadata(appMetadataManager, message.beaconId);
                    const request = {
                        appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            case __1.BeaconMessageType.BroadcastRequest:
                {
                    const appMetadata = await IncomingBeaconMessageInterceptor.getAppMetadata(appMetadataManager, message.beaconId);
                    const request = {
                        appMetadata,
                        ...message
                    };
                    interceptorCallback(request, connectionInfo);
                }
                break;
            default:
                console.log('Message not handled');
        }
    }
    static async getAppMetadata(appMetadataManager, beaconId) {
        const appMetadata = await appMetadataManager.getAppMetadata(beaconId);
        if (!appMetadata) {
            throw new Error('AppMetadata not found');
        }
        return appMetadata;
    }
}
exports.IncomingBeaconMessageInterceptor = IncomingBeaconMessageInterceptor;
//# sourceMappingURL=IncomingBeaconMessageInterceptor.js.map